import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Twitter } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Footer = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter/subscribe`, { email });
      toast.success('Successfully subscribed to newsletter');
      setEmail('');
    } catch (error) {
      toast.error('Failed to subscribe');
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="border-t border-neutral-800 bg-[#050505]">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <span className="font-['Syne'] text-2xl font-bold tracking-tight">
                LOSTNFOUND<span className="text-[#FF3B30]">860</span>
              </span>
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed mb-6">
              Premium streetwear for the whole family. Urban style that doesn't compromise on quality.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="p-2 border border-neutral-800 hover:border-white transition-colors" data-testid="social-instagram">
                <Instagram size={18} />
              </a>
              <a href="#" className="p-2 border border-neutral-800 hover:border-white transition-colors" data-testid="social-twitter">
                <Twitter size={18} />
              </a>
            </div>
          </div>

          {/* Shop Links */}
          <div>
            <h4 className="uppercase text-xs tracking-widest mb-6">Shop</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/shop/men" className="text-muted-foreground hover:text-white transition-colors text-sm">
                  Men
                </Link>
              </li>
              <li>
                <Link to="/shop/women" className="text-muted-foreground hover:text-white transition-colors text-sm">
                  Women
                </Link>
              </li>
              <li>
                <Link to="/shop/kids" className="text-muted-foreground hover:text-white transition-colors text-sm">
                  Kids
                </Link>
              </li>
              <li>
                <Link to="/shop/accessories" className="text-muted-foreground hover:text-white transition-colors text-sm">
                  Accessories
                </Link>
              </li>
              <li>
                <Link to="/drops" className="text-muted-foreground hover:text-white transition-colors text-sm">
                  Drops
                </Link>
              </li>
            </ul>
          </div>

          {/* Help Links */}
          <div>
            <h4 className="uppercase text-xs tracking-widest mb-6">Help</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/size-guide" className="text-muted-foreground hover:text-white transition-colors text-sm">
                  Size Guide
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-muted-foreground hover:text-white transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <a href="#" className="text-muted-foreground hover:text-white transition-colors text-sm">
                  Shipping Info
                </a>
              </li>
              <li>
                <a href="#" className="text-muted-foreground hover:text-white transition-colors text-sm">
                  Returns & Exchanges
                </a>
              </li>
              <li>
                <a href="#" className="text-muted-foreground hover:text-white transition-colors text-sm">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="uppercase text-xs tracking-widest mb-6">Newsletter</h4>
            <p className="text-muted-foreground text-sm mb-4">
              Get early access to drops, exclusive offers, and more.
            </p>
            <form onSubmit={handleSubscribe} className="flex flex-col space-y-3">
              <Input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="bg-neutral-900 border-neutral-800 rounded-none"
                data-testid="newsletter-email"
              />
              <Button 
                type="submit" 
                disabled={loading}
                className="btn-primary w-full rounded-none"
                data-testid="newsletter-submit"
              >
                {loading ? 'Subscribing...' : 'Subscribe'}
              </Button>
            </form>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-neutral-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-muted-foreground text-xs">
            © 2024 LostNFound860. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="#" className="text-muted-foreground hover:text-white transition-colors text-xs">
              Privacy Policy
            </a>
            <a href="#" className="text-muted-foreground hover:text-white transition-colors text-xs">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
